<template>
  <div class="card-right">
    <div class="card-content d-block p-10">
      <div class="flex-container panel-head mt-m10">
        <div class="flex-item">
          <p>
            {{$t('INDENT_SHIP_TO')}} :
            <strong class="text-bold">
              {{ shipTO }}
            </strong>
          </p>
          <p>
            {{$t('INDENT_SOLD_TO')}} :
            <strong class="text-bold">
              {{ shipTO }}
            </strong>
          </p>
          <p v-if="consignee.reported_at">
            {{$t('INDENT_REACHED')}} :
            <strong class="text-bold">
              {{ formatDate(consignee.reported_at) }}
            </strong>
          </p>
          <p v-if="consignee.release_at">
            {{$t('INDENT_RELEASED')}} :
            <strong class="text-bold">
              {{ formatDate(consignee.release_at) }}
            </strong>
          </p>
          <p v-if="rejectedReason && showRejectReason" class="text-red">
            {{$t('INDENT_REJECTION_REASON')}} :
            <strong class="text-bold">
              {{ rejectedReason }}
            </strong>
          </p>
        </div>
        <div class="flex-item text-right ml-auto">
          <p class="list-badge">
            <span class="badge">{{$t('ACTUAL_INDENT_WEIGHT')}}</span>
              <label v-if="actualSummaryByDestinationId && actualSummaryByDestinationId.total_weight && actualSummaryByDestinationId.total_weight.value">{{ fixTwoDigits(actualSummaryByDestinationId.total_weight.value) }} {{ actualSummaryByDestinationId.total_weight.unit }}</label>
              <label v-else>{{ materialSummary.weight }}</label>
            <span class="badge">{{$t('ACTUAL_INDENT_VOLUME')}}</span>
              <label v-if="actualSummaryByDestinationId && actualSummaryByDestinationId.total_volume &&  actualSummaryByDestinationId.total_volume.value">{{ fixTwoDigits(getConvertedClientVolume(actualSummaryByDestinationId.total_volume.value)) }} {{ preferredVolumeUnit.toLowerCase() }}</label>
              <label v-else>{{ materialSummary.volume }}</label>
            <span class="badge">{{$t('ACTUAL_INDENT_QUANTITY')}}</span>
            <template v-if="actualSummaryByDestinationId && actualSummaryByDestinationId.total_quantity_nos && actualSummaryByDestinationId.total_quantity_cs">
                    <span v-if="actualSummaryByDestinationId.total_quantity_nos && actualSummaryByDestinationId.total_quantity_nos.value">
                      {{fixTwoDigits(
                        actualSummaryByDestinationId.total_quantity_nos.value
                      )}}
                      {{ actualSummaryByDestinationId.total_quantity_nos.unit }}
                    </span>
                    <span
                      v-if="actualSummaryByDestinationId.
                          total_quantity_cs && actualSummaryByDestinationId.total_quantity_cs.value"
                    >
                    {{fixTwoDigits(
                      actualSummaryByDestinationId.total_quantity_cs.value
                      )}}
                      {{actualSummaryByDestinationId.total_quantity_cs.unit}}
                    </span>
            </template>
            <template v-else>
              <label>{{materialSummary.quantity}}</label>
            </template>

            <span class="badge">{{$t('INDENT_WEIGHT')}}</span>
            <label>{{materialSummary.weight}}</label>
            <span class="badge">{{$t('INDENT_VOLUME')}}</span>
            <label>{{materialSummary.volume}}</label>
            <span class="badge">{{$t('INDENT_QUANTITY')}}</span>
            <label>{{materialSummary.quantity}}</label>
          </p>
          <p class="list-badge">
                <span v-if="consignee.collection_amount" class="text-xs status" :class="getClass">
                  {{ $t('CASH_ON_DELIVERY') }} :
                  <svgicon :name="getSvgIconIndent" width="10" height="10" :original="true" />
                  <strong class="text-bold">{{consignee.collection_amount}}</strong>
                </span>
                <span v-if="consignee.collection_amount" class="ml-4">
                  <Tooltip :open-delay="200" effect="dark" placement="bottom-start">
                    <div v-if="!consignee.is_cash_collected" slot="content">{{ $t('INDENT_YET_TO_COLLECT_CASH') }}</div>
                    <div v-else slot="content">{{ $t('INDENT_CASH_COLLECTED') }}</div>
                    <svgicon name="icon-info-circle" width="14" height="14" :original="true" />
                  </Tooltip>
                </span>
          </p>
          <div v-if="returnMaterialsEnabled">
            <div class="flex-item text-right ml-auto pl-10 return-material-btn" v-if="consigneeMaterials &&
              consigneeMaterials.materials && consigneeMaterials.materials.length">
              <div style="position: relative;left: 45px;" v-if="grnEditabilityCheckBasedOnApprovalStatus">
                <Tooltip v-if="!canShowSaveGRN" popper-class="max-width" :open-delay="200" effect="dark" placement="bottom-start">
                  <div slot="content">{{ $t('EDIT_EPOD_TO_SAVE') }}</div>
                  <span  class="pointer">
                    <Button size="medium"
                      v-if="enableShow"
                      type="secondary"
                      @click="confirmSave"
                      :disabled="!canShowSaveGRN || !hasUserEdited">{{$t('INDENT_SAVE')}}</Button>
                  </span>
                </Tooltip>
                <div style="position: relative;" v-else>
                  <Button size="medium"
                    v-if="enableShow"
                    type="secondary"
                    @click="confirmSave"
                    :disabled="!canShowSaveGRN || !hasUserEdited">{{$t('INDENT_SAVE')}}
                  </Button>
                </div>
              </div>
              <div v-if="canShowReturnMaterials && hasRemainingMaterials">
                <div v-if="returnMaterialLoader" style="height: 30px;">
                  <Spinner />
                </div>
                <Button size="medium"
                  v-else
                  type="secondary"
                  @click="saveReturnMaterials"
                  :disabled="!showReturnMaterialSave">{{$t('UPDATE_RETURN_MATERIALS')}}
                </Button>
                <div style="position:relative; top: 10px; right:5px">
                  <Checkbox :value="returnAllMaterials" @input="handleReturnAllMaterials"
                      class="text-label text-lowercase"
                    >
                      {{$t('MARK_ALL_RETURN')}}
                    </Checkbox>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="flex-item text-right ml-auto pl-10" v-if="consigneeMaterials &&
              consigneeMaterials.materials && consigneeMaterials.materials.length && grnEditabilityCheckBasedOnApprovalStatus">
              <div>
                <Tooltip v-if="!canShowSaveGRN" popper-class="max-width" :open-delay="200" effect="dark" placement="bottom-start">
                  <div slot="content">{{ $t('EDIT_EPOD_TO_SAVE') }}</div>
                  <span  class="pointer">
                    <Button size="medium"
                      v-if="enableShow"
                      type="secondary"
                      @click="confirmSave"
                      :disabled="!canShowSaveGRN || !hasUserEdited">{{$t('INDENT_SAVE')}}</Button>
                  </span>
                </Tooltip>
                <div style="position: relative;" v-else>
                  <Button size="medium"
                    v-if="enableShow"
                    type="secondary"
                    @click="confirmSave"
                    :disabled="!canShowSaveGRN || !hasUserEdited">{{$t('INDENT_SAVE')}}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="no-data" v-if="isMaterialsLoading">{{$t('INDENT_MATERIAL_LOADING')}}</div>
      <div class="no-data" v-else-if="!consigneeMaterials.materials
        || !consigneeMaterials.materials.length">{{$t('INDENT_NO_MATERIALS')}}</div>
        <materials-division
          v-for="(category,index) in Object.keys(materialsByCategory)"
          :key="index"
          :fixedColumns="fixedColumns"
          :materialData="materialsByCategory[category]"
          :originalMaterialSummaries="materialDetails.original_material_quantities"
          :modifiedMaterials.sync="modifiedMaterials"
          :orderNo="orderNo"
          :slidableColumns="slidableColumns"
          :isEpodVisible="isEpodVisible"
          :isEpodEditable="grnEditabilityCheckBasedOnApprovalStatus"
          :movement="movement"
          :orderStatus="orderDetails.status"
          :editedPackageDetails="editedPackageDetails"
          :canShowReturnMaterials="canShowReturnMaterials"
          :materialCustomColumn="materialCustomColumn"
          @update-comment="updateComment"
          @changePackageStatus="changePackageStatus"
          @addModifiedMaterials="addModifiedMaterials"
        />
        <Collapse accordion class="collapse-slider mt-15" v-if="showMaterialAccess">
          <CollapseItem :title="'EXCESS MATERIAL DETAIL'" name="1">
          <MaterialExcess
          ref="material_excess"
          :selectedConsignee="consignee"
          :excessMaterials="excessMaterials"
          @refetch-excess-materials="getMaterialExcess"
          :materialHeaders="fixedColumns"
          :orderDetails="orderDetails"
          ></MaterialExcess>
        </CollapseItem>
        </Collapse>
    </div>
  </div>
</template>
<script>
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable func-names */
import { mapGetters } from 'vuex';
import { Messages } from '@/constants/messages';
import { groupBy, isEmpty } from 'lodash';
import { LorryReceiptGenerationCategory, deliveryTypes, quantityUnitsForPieces,
  orderDestinationType, auditPlatform, epodApprovalStatus } from 'pando-constants';
import debounce from 'debounce';
import materialsDivision from './materialsDivision';
import moment from 'moment';
import MaterialExcess from '@common/components/material-excesss';
import VolumeFormulaConvertor from '../../../../../../../common-v2/helpers/volume-formula-converter';

export default {
  name: 'materialsConsignee',
  created() {
    this.$store.commit('indents/setCanShowSaveGRN', false);
    this.getMaterialExcess();
    if (this.consignee && this.consignee.epod_rejected) {
      this.rejectedReason = this.consignee.epod_rejected.reason;
      this.showRejectReason = true;
    }
    if (this.consignee && this.consignee.is_transporter_updated) {
      this.showRejectReason = false;
    }
  },
  props: {
    consignee: {
      type: Object,
      default: () => {},
    },
    fixedColumns: {
      type: Array,
      default: () => [],
    },
    slidableColumns: {
      type: Array,
      default: () => [],
    },
    deliveryType: {
      type: String,
      default: 'FTL',
    },
    isMaterialsLoading: {
      type: Boolean,
      default: true,
    },
    materialDetails: {
      type: Object,
      default: () => {},
    },
    orderSummary: {
      type: Object,
      default: () => null,
    },
    orderNo: {
      type: String,
    },
    isEpodVisible: {
      type: Boolean,
      default: true,
    },
    isEpodEditable: {
      type: Boolean,
      default: false,
    },
    lrGenerateCategory: {
      type: Number,
      default: 1,
    },
    source: {
      type: Object,
      default: () => {},
    },
    movement: {
      type: Number,
    },
    isMultiDropGateConfig: {
      type: Boolean,
      default: false,
    },
    unsavedReturnMaterialDetails: {
      type: Object,
      default: () => ({}),
    },
    configurations: {
      type: Object,
      default: () => ({}),
    },
    orderDetails: {
      type: Object,
      default: () => ({}),
    },
    materialCustomColumn: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    materialsDivision,
    MaterialExcess,
  },
  data() {
    return {
      modifiedMaterials: new Set(),
      Messages,
      editedPackageDetails: {},
      rejectedReason: '',
      showRejectReason: false,
      enableShow: true,
      deliveryTypes,
      quantityUnitsForPieces,
      returnMaterialLoader: false,
      returnAllMaterials: false,
      excessMaterials: [],
    };
  },
  computed: {
    ...mapGetters({
      canShowSaveGRN: 'indents/canShowSaveGRN',
      hasUserEdited: 'indents/hasUserEdited',
    }),
    preferredVolumeUnit() {
      return this.$preferredVolumeUnit();
    },
    returnMaterialsEnabled() {
      return this.$hasFeature('return_management');
    },
    canShowReturnMaterials() {
      const isAfterDispatched = this.$statusUtil.isAfterDispatched(this.orderDetails.status);
      let isWithinConfiguredDays = true;
      if (this.consignee.release_at) {
        const deliveredDate = moment(this.consignee.release_at).startOf('day');
        isWithinConfiguredDays = moment().diff(deliveredDate, 'days') < (this.configurations.return_delivery_creation_window_days || 90);
      }
      return this.returnMaterialsEnabled && isAfterDispatched &&
        this.consignee.type === orderDestinationType.CONSIGNEE && isWithinConfiguredDays;
    },
    showReturnMaterialSave() {
      return !isEmpty(this.unsavedReturnMaterialDetails);
    },
    consigneeMaterials() {
      if (this.isMultiDropGateConfig &&
          this.consignee.gate_id && this.materialDetails.materials) {
        const result = this.materialDetails;
        result.materials = this.materialDetails.materials.filter(material =>
          material.destination_gate_id === this.consignee.gate_id);
        return result;
      }
      return this.materialDetails;
    },
    // EPOD approval computed property.
    grnEditabilityCheckBasedOnApprovalStatus() {
      let result = this.isEpodEnableToEditGRN;
      const approvalStatus = this.orderDetails.epod_approval_status;
      if (approvalStatus !== epodApprovalStatus.PENDING) {
        result = this.orderDetails.epod_editability_based_on_approval_flow;
      }
      return result;
    },
    shipTO() {
      let shipToData = '';
      if (this.consignee.gate_id) {
        const gateDetail = this.consignee.address.gates.find(gate =>
          this.consignee.gate_id === gate._id);
        shipToData = `${gateDetail.reference_id} - ${gateDetail.name} - ${gateDetail.city}`;
      } else if (this.consignee.type === orderDestinationType.CONSIGNEE) {
        shipToData = `${this.consignee.address.reference_id} - ${this.consignee.address.name} - ${this.consignee.address.city}`;
      }
      return shipToData;
    },
    isEpodEnableToEditGRN() {
      const isNotTransporter = (this.consignee.grn_submitted_by &&
        this.consignee.grn_submitted_by.entity_type !== auditPlatform.TRANSPORTER) ||
        false;
      return (this.isEpodEditable && !this.consignee.is_transporter_updated &&
        !isNotTransporter);
    },
    getSvgIconIndent() {
      return this.consignee.is_cash_collected ? 'rupee' : 'rupee-error';
    },
    getClass() {
      return this.consignee.is_cash_collected ? 'status-green' : 'status-red';
    },
    hasPackages() {
      return !isEmpty(this.consigneeMaterials.packages);
    },
    materialsByCategory() {
      let tempResult = [];
      const result = {};
      if (this.lrGenerateCategory === LorryReceiptGenerationCategory.GATE_WISE) {
        tempResult = this.consigneeMaterials &&
          groupBy(this.consigneeMaterials.materials, 'source_location_reference_id');
        const gatesList = Object.keys(tempResult);
        gatesList.map((gate) => {
          if (this.source && this.source.address && this.source.address.gates) {
            const gateDetails = this.source && this.source.address.gates.find(item =>
              item.reference_id === gate);
            result[gate] = {
              title: 'Gate',
              category: gateDetails.name,
              materials: tempResult[gate],
              packages: this.consigneeMaterials.packages || [],
            };
          } else if (this.source.address.reference_id === gate) {
            const sourceDetails = this.source;
            result[gate] = {
              title: 'Gate',
              category: sourceDetails.address.name,
              materials: tempResult[gate],
              packages: this.consigneeMaterials.packages || [],
            };
          }
          return null;
        });
      } else {
        tempResult = this.consigneeMaterials &&
          groupBy(this.consigneeMaterials.materials,
            (item) => {
              let key = `${item.division}^${!isEmpty(item.business_division) && item.business_division}`;
              if (this.$hasFeature('primary_legal_entity') && item.clientLe) {
                key += `^${item.clientLe}`;
              }
              return key;
            });
        const divisionsList = Object.keys(tempResult);
        divisionsList.map((division) => {
          const divSplit = division.split('^');
          let matDivision = divSplit[0];
          const clientLe = divSplit[2];
          if (this.$hasFeature('primary_legal_entity') && clientLe) {
            matDivision += ` - ${clientLe}`;
          }
          result[division] = {
            title: 'Division',
            category: matDivision,
            business_division: tempResult[division][0].business_division,
            materials: tempResult[division],
            packages: this.consigneeMaterials.packages || [],
          };
          return null;
        });
      }
      return result;
    },
    materialSummary() {
      const defaultVal = {
        weight: { value: 0, unit: '' },
        volume: { value: 0, unit: '' },
        quantity: '',
        quantityByUnit: {},
      };
      if (this.consigneeMaterials && this.consigneeMaterials.materials) {
        let summary = this.consigneeMaterials.materials.reduce(
          (acc, material) => {
            if (!material.packages || !material.packages.length) {
              return this.getTotalAcc(acc, material);
            }
            return acc;
          }, defaultVal);
        if (this.consigneeMaterials.packages) {
          summary = Object.values(this.consigneeMaterials.packages).reduce(
            (acc, material) => this.getTotalAcc(acc, material), summary);
        }
        const quantityUnits = Object.keys(summary.quantityByUnit);
        let quantity = quantityUnits.reduce(
          (acc, unit) => `${acc} ${this.fixTwoDigits(summary.quantityByUnit[unit])} ${unit}`,
          '');

        let key = this.consignee && this.consignee.location_id.toString();
        if (this.isMultiDropGateConfig && key) {
          key = this.consignee.gate_id ? key.concat(`_${this.consignee.gate_id.toString()}`) : key;
        }

        const actualMaterials = (this.consigneeMaterials &&
         this.consigneeMaterials.actual_materials &&
         this.consigneeMaterials.actual_materials[key]) || {};

        const currentMaterialSummary = (this.consigneeMaterials &&
         this.consigneeMaterials.material_summary &&
         this.consigneeMaterials.material_summary[key]) || {};

        if (currentMaterialSummary) {
          summary.weight.value = currentMaterialSummary.weight || this.fixTwoDigits(summary.weight.value);
          summary.volume.value = currentMaterialSummary.volume || this.fixTwoDigits(summary.volume.value);
          quantity = currentMaterialSummary.quantity ?
            `${this.fixTwoDigits(currentMaterialSummary.quantity)} ${quantityUnits[0]}`
            : quantity;
        }

        return {
          weight: `${this.fixTwoDigits(summary.weight.value)} ${summary.weight.unit}`,
          volume: `${this.fixTwoDigits(this.getConvertedClientVolume(summary.volume.value))} ${this.preferredVolumeUnit.toLowerCase()}`,
          quantity,
          actual_weight: `${actualMaterials.total_weight > 0 ? this.fixTwoDigits(actualMaterials.total_weight) : this.fixTwoDigits(summary.weight.value)} ${summary.weight.unit}`,
          actual_volume: `${actualMaterials.total_volume > 0 ? this.fixTwoDigits(actualMaterials.total_volume) : this.fixTwoDigits(summary.volume.value)} ${summary.volume.unit}`,
          actual_quantity: `${actualMaterials.total_quantity > 0 ? `${this.fixTwoDigits(actualMaterials.total_quantity)} ${quantityUnits[0]}` : quantity}`,
        };
      }
      return {};
    },
    actualSummaryByDestinationId() {
      let key = this.consignee.location_id;
      if (this.isMultiDropGateConfig && this.consignee.gate_id) {
        key = key.concat(`_${this.consignee.gate_id.toString()}`);
      }
      const actualMaterials = this.consigneeMaterials.actual_materials[key];
      const chargeableWeight = this.consigneeMaterials.chargeable_weight;
      const isChargeableWeightsExists = !isEmpty(chargeableWeight) && ((chargeableWeight.csp_quantity + chargeableWeight.csp_weight + chargeableWeight.csp_volume) || 0) !== 0;
      const isActualQuantityExists = !isEmpty(actualMaterials) && ((actualMaterials.total_quantity + actualMaterials.total_weight + actualMaterials.total_volume) || 0) !== 0;
      // eslint-disable-next-line array-callback-return
      if (this.hasPackages && !isActualQuantityExists && !isChargeableWeightsExists) {
        return {};
      }
      const actualWeight = this.consigneeMaterials.materials.reduce((total, material) => {
        let locationId = material && material.destination_location_id.toString();
        if (this.isMultiDropGateConfig && material.destination_gate_id) {
          locationId = locationId.concat(`_${material.destination_gate_id.toString()}`);
        }
        if (!total[locationId]) {
          // eslint-disable-next-line no-param-reassign
          total[locationId] = {
            total_weight: { value: 0, unit: '' },
            total_volume: { value: 0, unit: '' },
            total_quantity_nos: { value: 0, unit: '' },
            total_quantity_cs: { value: 0, unit: '' },
          };
        }
        total[locationId].total_weight.value += Number(material.weight.value) || 0;
        total[locationId].total_weight.unit = material.weight.unit || 'kg';
        total[locationId].total_volume.value += Number(material.volume.value) || 0;
        total[locationId].total_volume.unit = material.volume.unit || 'cft';
        let quantityUnit = material.quantity.unit.toLowerCase();
        if (this.hasPackages && !material.quantity.actual_unit) {
          quantityUnit = this.materialSummary.actual_quantity.trim().split(' ')[1] || quantityUnit;
        }
        if (Object.keys(this.quantityUnitsForPieces).includes(quantityUnit)) {
          total[locationId].total_quantity_nos.value += material.quantity.value;
          total[locationId].total_quantity_nos.unit = 'pieces';
        } else {
          total[locationId].total_quantity_cs.value += material.quantity.value;
          total[locationId].total_quantity_cs.unit = 'cases';
        }
        return total;
      }, {});
      return actualWeight[key] ? actualWeight[key] : {};
    },
    hasRemainingMaterials() {
      if (this.materialDetails && this.materialDetails.materials) {
        return !!this.materialDetails.materials.find(material =>
          (material.quantity.value - (material.epod.shortage_count || 0) - (material.return_count || 0)) > 0);
      }
      return false;
    },
    showMaterialAccess() {
      return this.$hasFeature('enable_material_excess');
    },
  },
  methods: {
    handleReturnAllMaterials($event) {
      this.returnAllMaterials = $event;
      if ($event) {
        this.$store.commit('indents/setReturnMaterialDetails', this.getReturnAllMaterials());
      } else {
        this.$store.commit('indents/setReturnMaterialDetails', {});
      }
    },
    getReturnAllMaterials() {
      return this.materialDetails.materials.reduce((acc, material) => {
        const returnMaterials = material.quantity.value - (material.epod.shortage_count || 0) - (material.return_count || 0);
        if (returnMaterials > 0) {
          acc[material.id] = returnMaterials;
        }
        return acc;
      }, {});
    },
    clearReturnMaterialDetails() {
      if (this.returnMaterialsEnabled) {
        this.returnAllMaterials = false;
        this.$store.commit('indents/setReturnMaterialDetails', {});
        this.$store.commit('indents/setReturnMaterialsWarnedOnce', false);
      }
    },
    constructReturnMaterialPayload() {
      let destinationLocationId = null;
      const destinationGateIds = this.materialDetails.materials.reduce((acc, material) => {
        if (this.unsavedReturnMaterialDetails[material.id]) {
          acc.add(material.source_gate_id);
          destinationLocationId = material.source_location_id;
        }
        return acc;
      }, new Set());
      const returnMaterials = Object.entries(this.unsavedReturnMaterialDetails).map(keyVal => ({
        material_id: keyVal[0],
        return_count: Number(keyVal[1]),
      }));
      return {
        destination_location_id: destinationLocationId,
        destination_gate_ids: [...destinationGateIds],
        return_materials: returnMaterials,
      };
    },
    async saveReturnMaterials() {
      this.returnMaterialLoader = true;
      const data = this.constructReturnMaterialPayload();
      const indentNo = this.orderNo;
      const consigneeId = this.consignee.location_id;
      const result = await this.$store
        .dispatch('indents/saveReturnMaterials', { data, indentNo, consigneeId });
      if (result.data) {
        this.$successMessage({ message: this.$t('RETURN_DELIVERIES_CREATION_SUCCESS') });
        this.$emit('update-returned-materials', result.data);
        this.clearReturnMaterialDetails();
      } else if (result.error) {
        this.$errorMessage({ message: result.error });
      } else {
        this.$errorMessage({ message: this.$t('RETURN_DELIVERIES_CREATION_FAILED') });
      }
      this.returnMaterialLoader = false;
    },
    fixTwoDigits(val) {
      const value = Number(val);
      return parseFloat(value.toFixed(2));
    },
    getTotalAcc(total, material) {
      const acc = total;
      const unit = (material.quantity.actual_unit || material.quantity.unit).toLowerCase();
      const unitText = this.unitText(unit);
      if (acc.quantityByUnit[unitText]) {
        acc.quantityByUnit[unitText] += material.quantity.value;
      } else { acc.quantityByUnit[unitText] = material.quantity.value; }
      acc.weight.value += material.weight.value;
      acc.weight.unit = material.weight.unit;
      acc.volume.value += material.volume.value;
      acc.volume.unit = material.volume.unit;
      return acc;
    },
    unitText(unit) {
      if (Object.keys(this.quantityUnitsForPieces).includes(unit)) {
        return 'pieces';
      }
      return 'cases';
    },
    formatDate(date) {
      return date ? this.$moment(date).format('DD MMM YYYY hh:mm A') : null;
    },
    addModifiedMaterials(materialId) {
      this.modifiedMaterials = this.modifiedMaterials.add(materialId);
    },
    updateComment(data) {
      const materialIndex = this.consigneeMaterials.materials
        .findIndex(material => material.id === data.id);
      if (materialIndex !== -1) {
        this.consigneeMaterials.materials[materialIndex].epod.comment = data.comment;
        this.consigneeMaterials.materials[materialIndex].comment = data.comment;
        this.consigneeMaterials = { ...this.consigneeMaterials };
      }
    },
    changePackageStatus(packageId, key, value) {
      const obj = {};
      obj[key] = value;
      if (value) {
        if (key === 'is_package_shortage') {
          obj.is_package_damaged = false;
          this.$emit('resetMaterials', packageId, key);
        }
        if (key === 'is_package_damaged') {
          obj.is_package_shortage = false;
          this.$emit('resetMaterials', packageId, key);
        }
      } else {
        this.$emit('resetMaterials', packageId, key);
      }
      if (this.editedPackageDetails[packageId]) {
        this.editedPackageDetails[packageId] = Object
          .assign(this.editedPackageDetails[packageId], obj);
      } else {
        const newObj = {};
        newObj[packageId] = obj;
        this.editedPackageDetails = Object.assign(this.editedPackageDetails, newObj);
      }
      this.editedPackageDetails = { ...this.editedPackageDetails };
      if (key && value) {
        this.updatePackageByPackageId(packageId, key);
      }
    },
    updatePackageByPackageId(packageId, key) {
      this.consigneeMaterials.materials.forEach((material, materialIndex) => {
        if (material.packages && material.packages.length &&
          material.packages.some(val => val.id === packageId)) {
          this.addModifiedMaterials(this.consigneeMaterials.materials[materialIndex].id);
        }
      });
      this.$emit('updatePackageByPackageId', packageId, key);
      this.$store.commit('indents/hasUserEdited', true);
    },
    getEditedPackagesData() {
      const result = [];
      Object.entries(this.editedPackageDetails).forEach(([id, data]) => {
        const obj = data;
        obj.id = id;
        result.push(obj);
      });
      return result;
    },
    async confirmSave() {
      const hasConfirm = await this.$PromptConfirm(this.$t('MDM_UPDATE_SHORTAGES_AND_DAMAGES_CONFIRMATION_MESSAGE'), this.$t('CONFIRMATION'), {
        confirmButtonText: this.$t('MDM_CONFIRM'),
        cancelButtonText: this.$t('MDM_CANCEL'),
        lockScroll: true,
        showClose: false,
        center: false,
        dangerouslyUseHTMLString: true,
        customClass: 'message-box',
      });
      if (hasConfirm === 'confirm') {
        this.saveGrn();
      }
    },
    saveGrn: debounce(async function () {
      try {
        this.showRejectReason = false;
        this.enableShow = false;
        // this.$store.commit('indents/setCanShowSaveGRN', false);
        this.$store.commit('indents/hasUserEdited', false);
        this.$store.commit('indents/hasWarnedOnce', false);
        if (this.consigneeMaterials) {
          const consigneeNo = this.consignee.location_id;
          const consigneeGateId = this.consignee.gate_id;
          const consigneeLocationId = this.consignee.location_id;
          const editedMaterails = this.consigneeMaterials.materials.filter(
            material => this.modifiedMaterials.has(material.id));
          const materials = editedMaterails.map((material) => {
            const obj = { ...material.epod };
            obj.id = material.id;
            obj.comment = material.comment || '';
            delete obj.is_submited;
            return obj;
          });
          const packages = this.getEditedPackagesData();
          const data = { materials, packages, consigneeGateId, consigneeLocationId };
          await this.$emit('updateGrn', { consigneeNo, data });
        }
        this.modifiedMaterials.clear();
        if (this.consignee &&
          this.consignee.epod_rejected &&
          this.consignee.epod_rejected.reason) {
          this.consignee.epod_rejected.reason = '';
        }
        this.enableShow = true;
        return 'done';
      } catch (error) {
        return error;
      }
    }, 100),
    async getMaterialExcess() {
      const routeParams = this.$route.params;
      const excessMaterialData = await this.$store.dispatch('order/getExcessMaterials', { orderId: this.$route.params.orderId || routeParams.orderNo });
      if (excessMaterialData && excessMaterialData.length > 0) {
        this.excessMaterials = excessMaterialData;
      } else {
        this.excessMaterials = [];
      }
    },
    getConvertedClientVolume(volume) {
      const volumeInClientUnit = new VolumeFormulaConvertor().revertToClient(this.preferredVolumeUnit, volume);
      return volumeInClientUnit;
    },
  },
};
</script>
<style lang="scss">
.return-material-btn {
  display: flex;
  justify-content: space-around;
  width: 43%;
  position: relative;
  top: 5px;
  right: 10px;
}
.spinner {
  position: absolute;
  right: 10px;
  width: 30px !important;
  height: 30px !important;
}
.message-box {
  position: fixed !important;
  top: 50px !important;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
}
</style>
